import React from 'react';
import _ from 'lodash';

import { Row, Col } from 'antd';

import { IShoppingToolbarItem } from '../../../../../models/Shopping';

import './checkout-toolbar.scss';

import CommandAddProduct from './components/CommandAddProduct/command-add-product';
import CommandDelete from './components/CommandDelete/command-delete';
import CommandExpand from './components/CommandExpand/command-expand';
import CommandExportPdf from './components/CommandExportPdf/command-export-pdf';
import CommandListView from './components/CommandListView/command-list-view';
import CommandTableView from './components/CommandTableView/command-table-view';
import CommandSapView from './components/CommandSapView/command-sap-view';
import CommandReprice from './components/CommandReprice/command-reprice';

interface ICheckoutToolbar {
    items?: IShoppingToolbarItem[]
}

const CheckoutToolbar: React.FunctionComponent<ICheckoutToolbar> = ({ items }) => {
    const _handleIconByType = (toolbarCommand: IShoppingToolbarItem) => {
        switch (toolbarCommand.type) {
            case 'add-product': {
                return (
                    <CommandAddProduct {...toolbarCommand} />
                );
            }
            case 'delete': {
                return (
                    <CommandDelete {...toolbarCommand} />
                );
            }
            case 'expand': {
                return (
                    <CommandExpand {...toolbarCommand} />
                );
            }
            case 'export-pdf': {
                return (
                    <CommandExportPdf {...toolbarCommand} />
                );
            }
            case 'list-view': {
                return (
                    <CommandListView {...toolbarCommand} />
                );
            }
            case 'table-view': {
                return (
                    <CommandTableView {...toolbarCommand} />
                );
            }
            case 'sap-view': {
                return (
                    <CommandSapView {...toolbarCommand} />
                );
            }
            case 'reprice': {
                return (
                    <CommandReprice {...toolbarCommand} />
                );
            }
            case 'separator': {
                return (
                    <span className="checkout-toolbar-separator"></span>
                );
            }
        }
    }

    return (
        <div className="checkout-toolbar-container">
            <Row gutter={[16, 0]}>
                {_.map(items, (dataItem, dataIndex) => (
                    <Col key={dataIndex}>
                        {_handleIconByType(dataItem)}
                    </Col>
                ))}
            </Row>
        </div>
    );
}

export default CheckoutToolbar;